module.exports = __webpack_public_path__ + "ipetbooking/admin/img/ga_4.9d07f95f.jpg";